import styles from './CategoryDivider.module.scss';

interface CategoryDividerProps {
    category: number;
}

const getCategoryName = (category: number): string => {
    switch(category) {
        case 1: return "Обучающие";
        case 2: return "Периодические";
        case 3: return "Глобальные";
        default: return `Категория ${category}`;
    }
};

export const CategoryDivider = ({ category }: CategoryDividerProps) => {
    return (
        <div className={styles.dividerContainer}>
            <div className={styles.categoryTitle}>{getCategoryName(category)}</div>
        </div>
    );
};